import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'

import type { SchemaAttributes } from '../types.js'
import type { MockServer, MirageServer } from './server.js'
import { getQueryParamValue } from './utils.js'

type ItalianMunicipalityData = SchemaAttributes<'ItalianMunicipality'>

export const model = Model as ModelDefinition<ItalianMunicipalityData>

export const factory = Factory.extend<ItalianMunicipalityData>({
  label(i: number) {
    return MUNICIPALITY_SEEDS[i]?.label ?? `MUNICIPALITY ${i}`
  },
})

const MUNICIPALITY_SEEDS = [
  { id: 'H501', label: 'ROMA' },
  { id: 'F205', label: 'MILANO' },
  { id: 'F839', label: 'NAPOLI' },
  { id: 'L219', label: 'TORINO' },
  { id: 'D612', label: 'FIRENZE' },
  { id: 'A944', label: 'BOLOGNA' },
  { id: 'G273', label: 'PALERMO' },
  { id: 'L736', label: 'VENEZIA' },
  { id: 'E205', label: 'GENOVA' },
  { id: 'D969', label: 'VERONA' },
]

export function routes(server: MockServer) {
  server.get(
    '/italian_municipalities',
    function (this: MirageServer, schema, request) {
      const municipalities = schema.all('italianMunicipality')
      const search = getQueryParamValue(request?.queryParams?.search)

      if (search) {
        const upperSearch = search.toUpperCase()
        const filtered = municipalities.filter((m) =>
          (m.label as string).includes(upperSearch),
        )
        return this.serialize(filtered)
      }

      return this.serialize(municipalities)
    },
  )
}

export function seeds(server: MockServer) {
  MUNICIPALITY_SEEDS.forEach(({ id, label }) => {
    server.create('italianMunicipality', { id, label })
  })
}
